// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","nav_items":"header_nav_items__--2ko"};